export class InvoiceDeliverable {
	public uuid: string;
	public title: string;
	public description: string;
	public quantity: number;
	public quantity_type: string = 'pcs';
	public rate: number;
	public is_taxable: boolean = true;
	// custom properties
	public temp_id: number;
	public edit: boolean = false;
	public add_to_store: boolean = false;
	public available_quantity: number;
	public id: number;
	public type: string;
	
	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);
		}
		this.temp_id = new Date().valueOf();
		this.edit = false;
	}

	public get cost() {
		return this.quantity * this.rate;
	}

}
